export enum AgencyStatus {
  pass = 1, // 审核通过
  pending = 2, // 待审核
  reject = 3, // 审核未通过
  toAccept = 5, // 审核中
  toActivate = 6, // 审核中
  pause = 10, // 储备
}

export enum ServiceType {
  adEfficiency = 1,
  privateDomain = 2,
  rta = 3,
  contentService = 4,
  dataService = 5,
  operateService = 6,
  other = 7,
}

export interface ImageFile {
  certification_image_id: number;
  image_url: string;
}

export interface File {
  created_time: string;
  file_name: string;
  file_url: string;
  id: number;
}

export interface AgencyInfo {
  agency_name: string;
  company_service_type: ServiceType;
  company_business: string;
  company_area_code: number;
  company_address: string;
  company_introduction: string;
  company_homepage: string;
  company_population: number;
  company_created_time: string;
  company_team: string;
}

export interface ContactInfo {
  manager_name: string;
  manager_mobile: string;
  manager_qq: string;
  manager_email: string;
  manager_wx: string;
  manager_type: 'qq' | 'wx';
}

export interface QualificationInfo {
  company_name: string;
  company_license_no: string;
  company_reg_address: string;
  company_capital_situation: number;
  company_expiretime: string;
  company_owner: string;
  company_owner_id_pic: Array<ImageFile>;
  mp_name: string;
  mp_id: string;
  company_certification: Array<ImageFile>;
  icp_no: string;
  company_copyright: string;
}

export interface AgencyAbility {
  service_industry: Array<{
    industry_id: string;
    industry_name?: string;
  }>;
  industry_customer_size: string;
  business_cooperation_cert: Array<File>;
  financing: number;
  financing_company: string;
  app_name: string;
  app_type: ServiceType;
  app_introduction: Array<File>;
  service_case: Array<File>;
  fees: Array<File>;
}

export interface Agency {
  authorize_file?: any;
  agency_id?: number;
  status?: AgencyStatus;
  audit_msg?: string;
  agency_info?: AgencyInfo;
  contact_info?: ContactInfo;
  qualification_management_info?: QualificationInfo;
  agency_ability?: AgencyAbility;
}
